"use strict";

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSubListDesign = exports.withSubLists = void 0;

var uuid_1 = require("uuid");

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var Chameleon_1 = require("../Chameleon");

var useChameleonOverrides = function useChameleonOverrides() {
  var isOn = Chameleon_1.useChameleonContext().isOn;
  return {
    icon: isOn ? 'repeat' : 'playlist_add',
    name: "chameleon-sublist-" + uuid_1.v1(),
    label: 'Sub',
    groupMerge: 'merge-up',
    formTitle: 'Sublist'
  };
};

var useToggleOverrides = function useToggleOverrides() {
  var isOn = Chameleon_1.useChameleonContext().isOn;
  return {
    isHidden: isOn,
    icon: 'playlist_add',
    name: "chameleon-sublist-" + uuid_1.v1(),
    label: 'Sub',
    groupMerge: 'merge-up',
    // label: 'Add',
    // groupLabel: 'Sublist',
    formTitle: 'Sublist'
  };
};

var getUseOverrides = function getUseOverrides(useOverrides) {
  if (useOverrides === void 0) {
    useOverrides = function useOverrides() {
      return {};
    };
  }

  return function (props) {
    var selectableComponents = Chameleon_1.useChameleonContext().selectableComponents;
    return Object.keys(selectableComponents).length > 1 ? __assign(__assign({}, useChameleonOverrides()), useOverrides(props)) : __assign(__assign({}, useToggleOverrides()), useOverrides(props));
  };
};

var asChameleonSubList = function asChameleonSubList(useOverrides) {
  return lodash_1.flow(Chameleon_1.applyChameleon, fclasses_1.withoutProps('onSubmit'), Chameleon_1.withChameleonComponentFormControls, Chameleon_1.withChameleonButton(getUseOverrides(useOverrides)), Chameleon_1.withChameleonContext('cham-sublist'));
};

var withSubListDesign$ = function withSubListDesign$(depth) {
  return function (design, hoc) {
    if (hoc === void 0) {
      hoc = lodash_1.identity;
    }

    return depth === 0 ? lodash_1.identity : fclasses_1.withDesign({
      Item: lodash_1.flow(hoc, fclasses_1.withDesign(design), fclasses_1.withDesign(Object.keys(design).reduce(function (acc, key) {
        var _a;

        return __assign(__assign({}, acc), (_a = {}, _a[key] = withSubListDesign$(depth - 1)(design, hoc), _a));
      }, {})))
    });
  };
};

var withSubListDesign = function withSubListDesign(depth) {
  return function (withDesign$, hoc) {
    if (hoc === void 0) {
      hoc = lodash_1.identity;
    }

    return typeof withDesign$ === 'function' ? withSubListDesign$(depth)({
      SubList: withDesign$
    }, hoc) : withSubListDesign$(depth)(withDesign$, hoc);
  };
};

exports.withSubListDesign = withSubListDesign;
/**
 * Attaches nested chameleon sublists of arbitrary depth to a list.
 *
 * This returns a function which takes a sublist definition, either as a single HOC or a
 * design.  If a single HOC is provided, the effect is a single sublist type which can
 * be toggled on and off.  If a design is provided, the effect is a set of different
 * sublist types which can be swapped (eg for different bullet styles).
 *
 * @param Depth The number of nested sublists to attach.
 * @return An function accepting a sublist definition and returning an HOC which adds the sublists.
 */

var withSubLists = function withSubLists(depth, useOverrides) {
  return function (asSubList$) {
    return withSubListDesign(depth)(asSubList$, asChameleonSubList(useOverrides));
  };
};

exports.withSubLists = withSubLists;
exports.default = asChameleonSubList;